const { default: layer_helper } = require('./_layer_helper');

import('./basemap.css');

var BasemapComponent = L.Control.extend({
    isOpen:false,
    options: {
        position: 'bottomleft',
    },

    initialize: function(layers, options){
        this.options = L.Util.extend({}, this.options, options);
        this.layers = layers
    },

    onAdd: function (map){
        const container = this.container = L.DomUtil.create('div', 'leaflet-control-basemapsSwitcher');
        
        this._createItems(map);
        this._collapse();

        container.addEventListener('mouseover', () => {
            this._expand();
        })

        container.addEventListener('mouseout', () => {
            this._collapse();
        })

        container.addEventListener('mouseup', () => {
            if(!this.isOpen){
                this._expand();
            // } else {
                // this._expand();
            }
            
        })

        return container;
    },

    _createItems(map) {
        
        this.layers.forEach( (obj, index) => {
            
            this.layers[index] = layer_helper.layerTileByName(obj.title)
            obj = this.layers[index]

            if(index === 0){
                obj.layer.addTo(map)
            }
            obj.id = index

            const imgContainer = L.DomUtil.create('div', 'basemapImg');
            const img = L.DomUtil.create('div');
            const name_el = L.DomUtil.create('div', 'name');
            const check = L.DomUtil.create('div', 'check');
            name_el.innerHTML = obj.title

            if(obj.layer?._map){
                this.activeMap = obj
                check.classList.add('activeMap');
            }
            
            img.style.backgroundImage = `url(${obj.icon})`;
            imgContainer.append(img)
            img.append(check)
            img.append(name_el)
            
            imgContainer.addEventListener('click', () =>{

                this._removeLayers(obj.layer);
                
                if(!obj.layer?._map){
                    obj.layer.addTo(this._map);
                    obj.layer.bringToBack()
                    this.activeMap = obj;
                    this._collapse();
                    this._map.fire('basemapChange', { baselayer: obj });

                    check.classList.add('activeMap');
                }

            })

            this.container.append(imgContainer)

        })
    },

    _removeLayers(layer){

        this.layers.forEach( (obj) =>{
            if(obj.layer._leaflet_id !== layer._leaflet_id && obj.layer?._map) {
                this._map.removeLayer(obj.layer);
            }
        })
    },

    _collapse(){
        this.isOpen = false
        this.container.childNodes.forEach( (child, index) => {

            if(index !== this.activeMap.id){
                child.classList.add('hidden')
                let check = child.querySelector('.check')
                check.classList.remove('activeMap')
            }
        })

    },

    _expand(){
        this.isOpen = true
        this.container.childNodes.forEach( (child) => {
            child.classList.remove('hidden')
        })
    }

})

L.basemapComponent = function(layers, options){
    return new BasemapComponent(layers, options);  
}